import { useGetQuery } from "@src/appV2/api";
import {
  SolveWorkedUnpaidBreaksStageResponse,
  solveWorkedUnpaidBreaksStageResponseSchema,
} from "./getSolveUnpaidBreaksStage";
import { environmentConfig } from "@src/appV2/environment";
import { UseQueryResult } from "@tanstack/react-query";
import { isDefined } from "@clipboard-health/util-ts";

export function useGetSolveUnpaidBreaksStage(
  facilityId?: string
): UseQueryResult<SolveWorkedUnpaidBreaksStageResponse> {
  return useGetQuery({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/facilityprofile/${facilityId}/solveWorkedUnpaidBreaksStageWithTargeting`,
    responseSchema: solveWorkedUnpaidBreaksStageResponseSchema,
    meta: {
      logErrorMessage:
        "Fetching SolveWorkedUnpaidBreaksStageWithTargeting flag value for facility failed.",
    },
    enabled: isDefined(facilityId),
  });
}
